import { useState } from 'react';
import { faqList } from '@/mocks/movies';

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-3xl mx-auto text-center">
          <span className="inline-flex items-center gap-2 text-accent-600 text-xs md:text-sm font-medium tracking-wide">
            <i className="ri-question-answer-line" />
            常见问题
          </span>
          <h2 className="mt-3 font-heading font-bold text-2xl md:text-4xl text-foreground-950 text-balance">
            关于九七电影院的常见疑问
          </h2>
          <p className="mt-4 text-foreground-700 text-sm md:text-base leading-relaxed">
            下面整理了访问本站时最常被问到的几个问题，点击标题即可展开查看完整说明。
          </p>
        </div>

        <div className="mt-9 max-w-3xl mx-auto flex flex-col gap-3">
          {faqList.map((item, idx) => {
            const open = openIndex === idx;
            return (
              <div
                key={item.q}
                className="rounded-lg bg-background-50 border border-background-200/80 overflow-hidden"
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(open ? null : idx)}
                  aria-expanded={open}
                  className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left hover:bg-background-100/70 transition-colors"
                >
                  <span className="flex items-start gap-3">
                    <span className="w-6 h-6 shrink-0 flex items-center justify-center rounded-md bg-primary-100 text-primary-700 text-xs font-semibold mt-0.5">
                      Q
                    </span>
                    <span className="font-heading font-semibold text-sm md:text-base text-foreground-950">
                      {item.q}
                    </span>
                  </span>
                  <i
                    className={`shrink-0 text-lg text-foreground-500 transition-transform duration-300 ${
                      open ? 'ri-subtract-line rotate-180' : 'ri-add-line'
                    }`}
                  />
                </button>
                {open && (
                  <div className="px-5 pb-5 pl-14 animate-fade-in">
                    <p className="text-foreground-600 text-xs md:text-sm leading-relaxed">{item.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}